import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTOVERVIEWMODAL_LEGACY_FIELD_ORDER = [
  { type: 'heading', value: "Colors" },
  "background_color",
  "label_color",
  "icon_color",
  "icon_background_color",
  "button_background_color",
  "button_text_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartOverviewModalDescriptor: _generatedCartOverviewModalDescriptor,
  cartOverviewModalModalDefinition,
  cartOverviewModalDashboardLayout,
  cartOverviewModalConfig,
  cartOverviewModalResolveConfig,
  cartOverviewModalProperties,
} = doodModalConfig(
  {
    name: "Cart overview modal",
    handle: "cart-overview-modal",
    internal_name: "CartOverviewModal",
    componentType: 'CartOverviewModalComponent',
    category: 'modal',
    description: "Cart overview modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "cart-overview-modal",
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Background color"
      }
    }),
    label_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-800"},
      options: {
        "label": "Label color"
      }
    }),
    icon_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"primary-600"},
      options: {
        "label": "Icon color"
      }
    }),
    icon_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"primary-100"},
      options: {
        "label": "Icon background color"
      }
    }),
    button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"primary-600"},
      options: {
        "label": "Button background color"
      }
    }),
    button_text_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Button text color"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color", "label_color", "icon_color", "icon_background_color", "button_background_color", "button_text_color"],
          },
        ],
      },
    ],
  })
);

export function cartOverviewModalDescriptor(): IBlockDescriptor;
export function cartOverviewModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartOverviewModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartOverviewModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartOverviewModalDescriptor, cartOverviewModalProperties, fieldOrder);
}

export {
  cartOverviewModalModalDefinition,
  cartOverviewModalDashboardLayout,
  cartOverviewModalProperties,
  cartOverviewModalConfig,
  cartOverviewModalResolveConfig,
};

export type CartOverviewModalConfig = typeof cartOverviewModalConfig;
